//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { faChevronDown, faList } from '@fortawesome/pro-regular-svg-icons';

export default {
  name: 'ProductAttributesMobile',
  components: {
    ProductAttributes: () => import('@motionelements/product2025/src/sections/ProductAttributes.vue'),
  },
  props: {
    collapsed: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      faChevronDown,
      faList,
    };
  },
};
